import { useState, useCallback } from 'react'

function PermissionsOnboarding({ onDone }) {
  const [step, setStep] = useState('idle') // idle | requesting

  const dismiss = useCallback(() => {
    localStorage.setItem('wayfare_perms_v1', 'done')
    onDone()
  }, [onDone])

  const activate = useCallback(async () => {
    setStep('requesting')
    // Microphone (note dictation, where the platform allows it)
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
      stream.getTracks().forEach(t => t.stop())
    } catch (_) {}
    // Location — powers the proximity whispers + recognised serendipity. One-shot
    // prompt; coordinates are used only in memory, never transmitted or stored.
    try {
      if ('geolocation' in navigator) {
        await new Promise(res => navigator.geolocation.getCurrentPosition(
          () => res(), () => res(), { enableHighAccuracy: false, timeout: 8000, maximumAge: 600000 }
        ))
      }
    } catch (_) {}
    try {
      if ('Notification' in window) await Notification.requestPermission()
    } catch (_) {}
    dismiss()
  }, [dismiss])

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(0,0,0,0.55)',
      display: 'flex', alignItems: 'flex-end', justifyContent: 'center'
    }}>
      <div style={{
        background: '#FFF',
        borderRadius: '20px 20px 0 0',
        padding: '28px 24px 36px',
        width: '100%', maxWidth: '480px',
        boxShadow: '0 -4px 32px rgba(0,0,0,0.15)'
      }}>
        <h2 style={{ margin: '0 0 6px', fontSize: '18px', fontWeight: '700', color: '#2C2C2C' }}>
          Activa estas funciones
        </h2>
        <p style={{ margin: '0 0 20px', fontSize: '13px', color: '#666', lineHeight: '1.5' }}>
          Para sacar el máximo partido a Wayfare
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '14px', background: '#f9f6f2', borderRadius: '12px' }}>
            <span style={{ fontSize: '28px' }}>🎙️</span>
            <div>
              <p style={{ margin: '0', fontSize: '14px', fontWeight: '600', color: '#2C2C2C' }}>Dictar notas por voz</p>
              <p style={{ margin: '0', fontSize: '12px', color: '#888' }}>Escribe en el diario sin teclear</p>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '14px', background: '#f9f6f2', borderRadius: '12px' }}>
            <span style={{ fontSize: '28px' }}>📍</span>
            <div>
              <p style={{ margin: '0', fontSize: '14px', fontWeight: '600', color: '#2C2C2C' }}>Ubicación</p>
              <p style={{ margin: '0', fontSize: '12px', color: '#888' }}>Susurros del barrio y hallazgos fuera de ruta</p>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '14px', background: '#f9f6f2', borderRadius: '12px' }}>
            <span style={{ fontSize: '28px' }}>🔔</span>
            <div>
              <p style={{ margin: '0', fontSize: '14px', fontWeight: '600', color: '#2C2C2C' }}>Notificaciones</p>
              <p style={{ margin: '0', fontSize: '12px', color: '#888' }}>Avisos y recordatorios de tu viaje</p>
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', gap: '10px' }}>
          <button
            onClick={dismiss}
            disabled={step === 'requesting'}
            style={{
              flex: 1, padding: '12px',
              border: '1.5px solid #ddd', borderRadius: '10px',
              background: '#fff', color: '#666',
              fontSize: '14px', fontWeight: '600', cursor: 'pointer'
            }}
          >
            Ahora no
          </button>
          <button
            onClick={activate}
            disabled={step === 'requesting'}
            style={{
              flex: 2, padding: '12px',
              border: 'none', borderRadius: '10px',
              background: step === 'requesting' ? '#b5a898' : '#8B7355',
              color: '#fff',
              fontSize: '14px', fontWeight: '700',
              cursor: step === 'requesting' ? 'default' : 'pointer'
            }}
          >
            {step === 'requesting' ? 'Activando…' : 'Activar permisos'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default PermissionsOnboarding
